import { Map } from 'immutable';
import { ENGLISH } from 'constants/language';
import {
    CHANGE_LANGUAGE_SUCCESS,
    CHANGE_LANGUAGE_FAILED,
    FETCH_LOCALE_FILES_SUCCESS
} from 'constants/actionTypes';

const DEFAULT_LOCALE = ENGLISH;

const init = Map({
    language: DEFAULT_LOCALE,
    localeFilesFetched: false
});

export default function changeLanguageReducer(state = init, action) {
    const { payload } = action;

    switch (action.type) {
    case CHANGE_LANGUAGE_SUCCESS:
        return state.merge({ language: payload });
    case FETCH_LOCALE_FILES_SUCCESS:
        return state.merge({ localeFilesFetched: true });
    case CHANGE_LANGUAGE_FAILED:
        return state.merge({ language: DEFAULT_LOCALE });
    default:
        return state;
    }
}
